import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { Book } from '@mui/icons-material'
import { rxOpenTag } from '../../lib/rx_subject'

const TagButton = () => {
  const open = () => {
    rxOpenTag.next(true)
  }

  return (
    <Box>
      <Tooltip title="情報">
        <span>
          <IconButton size="large" color="inherit"
                      className="open-tag-button"
                      onClick={open}>
            <Book />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

export default TagButton
